define([
    'common/ui/view/svg/index',
    'common/ui/view/svg/util'
], function(
    SVGView,
    SVGUtil
    ) {
    var SVGTextareaView = SVGView.extend({
        tagName: 'foreignObject',

        initialize: function(params) {
            SVGTextareaView.__super__.initialize.call(this, params);
            this.width = params.width;
            this.height = params.height;
            this.offset = params.offset;
        },

        onRender: function() {
            this.$el
                .attr('width', this.width)
                .attr('height', this.height)
                .attr(
                    'transform',
                    SVGUtil.transform({
                        x: this.offset.x,
                        y: this.offset.y
                    })
                );

            this.$text = this.$el.append('xhtml:div')
                .style('height', this.height + 'px')
                .style('overflow', 'hidden')
                .style('word-break', 'break-word');

            return this;
        },

        text: function(text) {
            this.$text.html(text);
        }
    });

    return SVGTextareaView;
});



// WEBPACK FOOTER //
// ./common/ui/view/svg/text/area.js